import {apiErrorHandler} from '../services/api_error_handler/api_error_handler';

import axios from 'axios';

const instance = axios.create({
  baseURL: import.meta.env.VITE_EXP_REST_API_URL,
});

const OKTA_TOKEN_STORAGE = 'okta-token-storage';

export const setupAxiosClient = ({dispatch, getState}, axiosInstance) => {
  const onRequestSuccess = (config) => {
    config.headers['trace_id'] = sessionStorage.getItem('trace-id');

    let oktaTokenStoage =
      window.localStorage.getItem(OKTA_TOKEN_STORAGE) &&
      JSON.parse(window.localStorage.getItem(OKTA_TOKEN_STORAGE));
    if (oktaTokenStoage.accessToken) {
      config.headers[
        'Authorization'
      ] = `${oktaTokenStoage.accessToken.accessToken}`;
    }
    return config;
  };

  const onRequestError = (error) => Promise.reject(error.response);

  const onResponseSucess = (response) => response;
  const onResponseError = (error) => Promise.reject(error);

  axiosInstance.interceptors.request.use(onRequestSuccess, onRequestError);
  axiosInstance.interceptors.response.use(onResponseSucess, onResponseError);
};
export default instance;
